import { render, staticRenderFns } from "./BountiesView.vue?vue&type=template&id=1ecc7249&scoped=true"
import script from "./BountiesView.vue?vue&type=script&lang=js"
export * from "./BountiesView.vue?vue&type=script&lang=js"
import style0 from "./BountiesView.vue?vue&type=style&index=0&id=1ecc7249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc7249",
  null
  
)

export default component.exports